<template>
  <div>
    <!--FORM COMPONENT-->
    <form @submit.prevent="onSubmit">
      <div class="grey-text">
        <b-form-group :class="{ 'form-group--error': $v.user.email.$error }">
            <mdb-input icon="envelope" id="email"
                       label="User email" type="email"
                       v-model.trim="$v.user.email.$model" @input="clearForm"/>
            <div v-if="$v.user.email.$dirty">
              <div class="error" v-if="!$v.user.email.required">Field is required</div>
              <div class="error" v-if="!$v.user.email.email">Email mismatch. Example johndoe123@icipe.org</div>
            </div>
        </b-form-group>
      </div>
      <div class="d-flex justify-content-end">
        <mdb-btn class="my-0" outline="black" size="sm" type="submit">Search
          <i aria-hidden="true" class="fas fa-search"></i></mdb-btn>
      </div>
    </form>
    <br>

    <!-- DISPLAY COMPONENT -->
    <div v-if="this.sampleRequests.length">
      <table class="table table-hover">
        <thead class="blue-gradient white-text">
        <tr>
          <th scope="col"><em><b>ID</b></em></th>
          <th scope="col"><em><b>SAMPLE CODE</b></em></th>
          <th scope="col"><em><b>OWNER</b></em></th>
          <th scope="col"><em><b>PROJECT</b></em></th>
          <th scope="col"><em><b>REQUESTED AMOUNT</b></em></th>
          <th scope="col"><em><b>APPROVED AMOUNT</b></em></th>
          <th scope="col"><em><b>COLLECTED</b></em></th>
        </tr>
        </thead>
        <tbody>
        <tr :key="sample.id" v-for="(sample, index) in this.sampleRequests">
          <td> {{ index + 1 }}</td>

          <td v-if="sample.sample_code"> {{ sample.sample_code }}</td>
          <td v-else> N/A</td>
          <td v-if="sample.owner"> {{ sample.owner }}</td>
          <td v-else> N/A</td>
          <td v-if="sample.project"> {{ sample.project }}</td>
          <td v-else> N/A</td>
          <!-- this is the requested amount-->
          <td v-if="sample.amount"> {{ sample.amount }}</td>
          <td v-else> N/A</td>
          <!-- this is the approved amount-->
          <td v-if="sample.approved"> {{ sample.approved }}</td>
          <td v-else> N/A</td>

          <td>
            <div><switches v-model="sample.enabled" theme="bootstrap" color="success" type-bold="true"
                      :text-enabled="text_enabled" :text-disabled="text_disabled"></switches></div>
          </td>
          &nbsp;
        </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-end">
        <mdb-btn class="my-0" outline="blue" size="md" type="submit" @click="validateSampleRequestResponse">
          Submit
        </mdb-btn>
      </div>
    </div>
    <div v-else-if="this.request_made">
      <p><b><em>&nbsp;&nbsp; -- No Approved or Uncollected Sample requests found for {{ user.email }}</em></b></p>
    </div>
  </div>
</template>

<script>
import {email, required} from "vuelidate/lib/validators";
import {mdbBtn, mdbInput} from "mdbvue";
import axios from "axios";
import {complete_sample_request_resource} from "@/utils/api_paths";
import {handleError, pageStartLoader, secureStoreGetAuthString, showFlashMessage} from "@/utils/util_functions";
import Switches from "vue-switches";
import {APPROVED_STATUS, COLLECTED_STATUS} from "@/utils/constants";

export default {
 name: "CompleteSampleRequest",

  components: {mdbInput, mdbBtn, Switches},

  data(){
   return{
     sampleRequests: [],
     collectionResponse: [],

     user:{
       email: null
     },
     time: 2000,

     // switch-enabled
     enabled: false,

     // request flag
     request_made: false,

     // switch prop data
     text_enabled: "Collected",
     text_disabled: "Uncollected",
   }
  },

  validations: {
    user: {
      email: {required, email}
    }
  },

  methods: {
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }
      this.getApprovedSampleRequests();
    },

    clearForm(){
      this.enabled = false
      this.request_made = false
      this.sampleRequests = []
      this.collectionResponse = []
    },

    getApprovedSampleRequests(){
      this.clearForm();
      let loader = pageStartLoader(this)

      axios.get(complete_sample_request_resource, {
        headers: {
          email: this.user.email,
          Authorization: secureStoreGetAuthString()
        }
      }).then((response) => {
        setTimeout(()=> {
          loader.hide()
          this.request_made = true
          if (response.status === 200){
           this.sampleRequests = response.data.message
          }
        }, this.time)
      }).catch((error) => { handleError(this, error, loader) });
    },

    validateSampleRequestResponse(){
      for (let i=0; i < this.sampleRequests.length; i++){
        if (this.sampleRequests[i].enabled === true){
          this.sampleRequests[i].enabled =  COLLECTED_STATUS
        } else if (this.sampleRequests[i].enabled === false){
          // since they were not collected they will remain with approved status for future references
          this.sampleRequests[i].enabled = APPROVED_STATUS
        }

        let sampleRequestResponse = {
          'id': this.sampleRequests[i].code,
          'status': this.sampleRequests[i].enabled,
        }
        this.collectionResponse.push(sampleRequestResponse)
      }
      this.completeSampleRequest()
    },

    completeSampleRequest(){
      let loader =  pageStartLoader(this)

      axios.post(complete_sample_request_resource, {
      response: {
        completed_sample_requests: this.collectionResponse
      }
      }, {
        headers: {
          Authorization: secureStoreGetAuthString()
        }
      }).then((response) => {
        setTimeout(() => {
          if (response.status === 200){
            loader.hide()
            showFlashMessage(this, 'success', 'Success', response.data.message)
            this.clearForm()
          }
        })
      }).catch((error) => { handleError(this, error, loader) });
    }
  },
}
</script>
